import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';

export const FolderSelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DropboxPathRow = styled.div`
  margin-bottom: 1.2rem;
`;

export const FolderItem = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  padding: 1rem 1.2rem;
  border: 1px solid #ddd;
  border-radius: 0.8rem;
  margin-bottom: 0.8rem;
  cursor: pointer;
`;

export const FolderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const FolderCheckbox = styled.input`
  cursor: pointer;
`;

export const FolderInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FolderName = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
`;

export const FolderPath = styled.div`
  font-size: 1.2rem;
  opacity: 0.7;
`;

export const FolderMediaCount = styled.div`
  font-size: 1.4rem;
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  font-size: 1.4rem;
`;

export const SelectedCount = styled.div`
  margin-top: 1.2rem;
  font-size: 1.4rem;
`;

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    width: unset;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.4rem;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

export const DeleteButton = styled(Button)`
  border: 1px solid #d92d20;
  background: #fff;
  width: unset;
  padding-inline: 2.4rem;
  color: #d92d20;
`;

export const SubmitButton = styled(Button)`
  width: 16rem;
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: #ddd;
  margin: 1rem 0;
`;
